var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 20.486c0-3.024-2.285-4.827-5.008-5.408l-2 2.445M5 20.486c0-3.024 2.285-4.827 5.008-5.408l1.984 2.445m0 0v2.555M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-11 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user_circle.e457467b9b0347fb9b51220f8dd22349.svg";
export { ForwardRef as ReactComponent };